/* eslint-disable react-hooks/static-components */
import React, {Fragment, memo} from "react";
import PropTypes from "prop-types";
import BarPlot from "../../../Types/Bar";
import LinePlusSingleStat from "../../../Types/LinePlusSingleStat";
import SingleStat from "../../../Types/SingleStat";
import ThresholdPlot from "../../../Types/Threshold";
import XYPlot from "../../../Types/XY";
import EmptyGraphMessage from "../../EmptyGraphMessage";
import ErrorBoundary from "./viewErrorBoundary";
import ViewLoadingSpinner from "./ViewLoader";

/** This component does two things.
 * - Display loader if data is loading
 * - If data is loaded then check type from properties and display proper graph.
 */

const View = (props) => {
  const {chartData, loading = false, properties, timeZone = "UTC", windowPeriod} = props;
  const {type} = properties;

  const Plot = () => {
    switch (type) {
      case "xy":
      case "dual-graph":
      case "triple-graph":
        return (
          <XYPlot jsonData={chartData} properties={properties} timeZone={timeZone} />
        );

      case "bar":
        return (
          <BarPlot jsonData={chartData} properties={properties} timeZone={timeZone} />
        );

      case "threshold":
        return (
          <ThresholdPlot
            jsonData={chartData}
            properties={properties}
            timeZone={timeZone}
          />
        );

      case "line-plus-single-stat":
        return (
          <LinePlusSingleStat
            jsonData={chartData}
            properties={properties}
            timeZone={timeZone}
          />
        );

      case "single-stat":
        return <SingleStat jsonData={chartData} properties={properties} />;

      default:
        return (
          <EmptyGraphMessage
            message={`${type} chart is not supported. This will be added soon`}
          />
        );
    }
  };

  const emptyGraphMessage = windowPeriod
    ? "No transitions in the look-back period. Please expand the look-back period."
    : "No transitions.";

  return (
    <ErrorBoundary>
      <Fragment>
        {loading ? (
          <ViewLoadingSpinner />
        ) : (
          <Fragment>
            {chartData && chartData.length > 0 ? (
              <Plot />
            ) : (
              <EmptyGraphMessage message={emptyGraphMessage} />
            )}
          </Fragment>
        )}
      </Fragment>
    </ErrorBoundary>
  );
};

View.propTypes = {
  chartData: PropTypes.array.isRequired,
  properties: PropTypes.object.isRequired,
  timeZone: PropTypes.string,
  loading: PropTypes.bool,
  windowPeriod: PropTypes.string,
};

export default memo(View);
